/*
 * $Id:: DeactivateSuccessDialog.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    confirmButton: {
        backgroundColor: theme.palette.text.mainBlue,
        borderColor: theme.palette.text.mainBlue,
        minWidth: '66px',
        '&:hover': {
            backgroundColor: theme.palette.text.mainBlue,
        },
        '&:active': {
            backgroundColor: theme.palette.text.mainBlue,
        },
    },
}));

const DeactivateSuccessDialog = ({ open, onAccept }) => {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={onAccept} aria-labelledby="confirm-status-update-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{t('deactivate.success.title')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('deactivate.account.success')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className={classes.confirmButton} variant="contained" onClick={onAccept}>
                    {t('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeactivateSuccessDialog;
